import { render, staticRenderFns } from "./KanbanGroupOperationsQuota.vue?vue&type=template&id=af091be0&scoped=true&"
import script from "./KanbanGroupOperationsQuota.vue?vue&type=script&lang=js&"
export * from "./KanbanGroupOperationsQuota.vue?vue&type=script&lang=js&"
import style0 from "./KanbanGroupOperationsQuota.vue?vue&type=style&index=0&id=af091be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af091be0",
  null
  
)

/* custom blocks */
import block0 from "./KanbanGroupOperationsQuota.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./KanbanGroupOperationsQuota.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VProgressCircular,VRow})
